var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isloading ? _c("div", { staticClass: "loading" }) : _vm._e(),
      _vm._v(" "),
      _c("notice"),
      _vm._v(" "),
      _c("headers"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _vm.isinvitation ? _c("footers") : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticStyle: {
          width: "100%",
          height: "35px",
          background:
            "url('/static/img/footer_bg.png') center center/cover no-repeat"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1badc801", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1badc801","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = null
// module chunks = 